import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from 'components/Common';
import ImageContainer from 'components/ImageContainer';
import { imageBorderRadius } from 'themes';
import { isiOS } from 'config';

export const ITEM_WIDTH = 94;
const MARGIN_WIDTH = isiOS ? 7.5 : 8;

const AppImage = `
  background-position: center;
  border-radius: ${imageBorderRadius};
  height: 80px;
  margin: 7px;
  width: ${ITEM_WIDTH - 2 * MARGIN_WIDTH}px;
`;

const AppTitle = styled.div`
  font-size: 14px;
  height: 34px;
  letter-spacing: -0.4px;
  margin: 0;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${ITEM_WIDTH}px;
`;

const LinkItem = styled(Link)`
  display: inline-block;
  width: ${ITEM_WIDTH}px;
  user-drag: none;
  img {
    border-radius: ${imageBorderRadius};
  }
`;

const CarouselItem = ({ app, ...props }) => (
  <LinkItem
    to={`/app/${app.id}`}
    pageDirection="FORWARD"
    data-test-type="app-link"
    data-test-id={app.id}
    {...props}
  >
    <ImageContainer
      containerAttr={{
        iconPlaceholder: true,
        styles: AppImage,
        width: app.icon.width,
        height: app.icon.height
      }}
      imageAttr={{
        alt: app.name,
        src: app.icon.uri,
        draggable: false
      }}
    />
    <AppTitle>{app.name}</AppTitle>
  </LinkItem>
);

CarouselItem.propTypes = {
  app: PropTypes.shape({
    icon: PropTypes.shape({
      uri: PropTypes.string.isRequired
    }),
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default CarouselItem;
